import React, { useState } from "react";
import { ContentFormHome, ContentFormService, ContentFormClinic, ContentFormSterilization, ContentFormTeam, ContentFormEgypt, ContentFormContact, ContentFormBlog } from "../../Components";

const ContentForm = () => {
   
    const [path, setPath] = useState('Home')
    return (
        <div>
            {path === 'Home' ? (
                <ContentFormHome path={path} setPath={setPath}  />
            ) : path === 'Services' ? (
                <ContentFormService path={path} setPath={setPath} />
            ) : path === 'Our Clinic' ? (
                <ContentFormClinic path={path} setPath={setPath} />
            ) : path === 'Sterilization' ? (
                <ContentFormSterilization path={path} setPath={setPath} />
            ) : path === 'Our Team' ? (
                <ContentFormTeam path={path} setPath={setPath} />
            ) : path === 'Why Egypt' ? (
                <ContentFormEgypt path={path} setPath={setPath} />
            ) : path === 'Contact Us' ? (
                <ContentFormContact path={path} setPath={setPath} />
            ) : (
                <ContentFormBlog path={path} setPath={setPath} />
            )}
        </div>


    )
}

export default ContentForm